import { __require as r } from "./index20.mjs";
var i = r();
export {
  i as j
};
